import { ThemeProvider } from '@mui/material';
import { getTheme } from '@parsys/frontend_library';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';

import CopyButton from './CopyButton';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';
import { THEME_APP_NAME } from 'FRONTEND/utils/constants';

export default (element) => {
  const root = createRoot(element);
  const theme = getTheme({ app: THEME_APP_NAME, branding: window.branding });
  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <ThemeProvider theme={theme}>
        <CopyButton
          id={element.dataset.id}
          label={element.dataset.label}
          destinationFields={JSON.parse(element.dataset.destinationFields)}
          examType={element.dataset.examType}
          icon={element.dataset.icon}
        />
      </ThemeProvider>
    </ErrorBoundary>,
  );

  return () => {
    root.unmount();
  };
};
